import qtiConstants from '../../../qti/Constants';

const { PDFJS_ROOT } = qtiConstants.staticLibPaths;

const PDFJSLoader = {
    getAllFilesToCache() {
        return [
            { url: `${PDFJS_ROOT}build/pdf.js`, type: 'js' },
            { url: `${PDFJS_ROOT}web/viewer.js`, type: 'js' },
            { url: `${PDFJS_ROOT}web/viewer.css`, type: 'css' },
            { url: `${PDFJS_ROOT}web/locale/locale.properties`, type: 'properties' },
            { url: `${PDFJS_ROOT}web/images/texture.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-viewThumbnail.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-viewOutline.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-viewAttachments.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-sidebarToggle.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-search.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-zoomOut.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-zoomIn.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/toolbarButton-menuArrows.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/loading-small.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/loading-icon.gif`, type: 'image' },
            { url: `${PDFJS_ROOT}web/images/shadow.png`, type: 'image' },
            { url: `${PDFJS_ROOT}web/locale/nb-NO/viewer.properties`, type: 'properties' },
            { url: `${PDFJS_ROOT}web/locale/en-US/viewer.properties`, type: 'properties' },
            { url: `${PDFJS_ROOT}web/locale/en-GB/viewer.properties`, type: 'properties' },
            { url: `${PDFJS_ROOT}build/pdf.worker.js`, type: 'js' },
            { url: `${PDFJS_ROOT}web/images/loading-small.png`, type: 'image' },
        ];
    },

    /**
     * No loading mechanism for PDFJS yet.
     * @return {Promise<boolean>}
     */
    async init() {
        return Promise.resolve(false);
    },
};

export default PDFJSLoader;
